import { request } from '@/services/request/request.api'

import {
	IAutoFill,
	IDeleteForm,
	IFetchUploadForm,
	ISyncResponse,
	ISyncResponseStatus,
	TAutoFillResponse
} from '@/types/uploadForm.interface'

export const UploadFormService = {
	async getFormData(task_id: string): Promise<IFetchUploadForm> {
		return request<IFetchUploadForm>({
			url: `/shotlists/${task_id}/form`,
			method: 'GET'
		})
	},

	async sendFormData(
		task_id: string,
		data: IFetchUploadForm
	): Promise<IFetchUploadForm> {
		const payload: IFetchUploadForm = {
			is_completed: data.is_completed,
			platforms: data.platforms,
			platforms_order: data.platforms_order
		}

		const formData = new FormData()
		formData.append('data', JSON.stringify(payload))

		return request<IFetchUploadForm>({
			url: `/shotlists/${task_id}/form`,
			method: 'POST',
			data: formData
		})
	},
	async syncFormData(task_id: string): Promise<ISyncResponse> {
		return request<ISyncResponse>({
			url: `/shotlists/${task_id}/sync`,
			method: 'POST'
		})
	},
	async getSyncStatus(task_id: string): Promise<ISyncResponseStatus> {
		return request<ISyncResponseStatus>({
			url: `/shotlists/${task_id}/sync/status`,
			method: 'GET'
		})
	},
	async getAutoFill({
		target_language,
		source_language,
		data
	}: IAutoFill): Promise<TAutoFillResponse> {
		return request<TAutoFillResponse>({
			url: `/openai/translate/dict`,
			method: 'POST',
			data: {
				target_language,
				source_language,
				data
			}
		})
	},
	async deleteFormData(task_id: string): Promise<IDeleteForm> {
		return request<IDeleteForm>({
			url: `/shotlists/${task_id}/form`,
			method: 'DELETE'
		})
	}
}
